<template>
  <ODialog ref="dialog" :maxWidth="600" hideWhenLoading>
    <v-card v-if="hb != null">
      <ORow fill-x class="grey lighten-2">
        <v-tabs v-model="currentTab" background-color="transparent">
          <v-tab href="#overview">Geral</v-tab>
          <v-tab v-for="m in measures" :key="m.id">
            {{ m.measureType }}
          </v-tab>
        </v-tabs>

        <v-spacer />

        <v-btn icon :color="startColor" @click="markStart">
          <v-icon>mdi-ray-start</v-icon>
        </v-btn>
        <v-btn icon :color="endColor" @click="markEnd">
          <v-icon>mdi-ray-end</v-icon>
        </v-btn>

        <v-btn icon @click="$refs.dialog.$dismiss" class="mr-2 ml-2">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </ORow>

      <v-card-text class="pa-6 scroll-y hb-dialog">
        <v-tabs-items v-model="currentTab" touchless>
          <v-tab-item value="overview">
            <pre>{{ overview | prettyJson }}</pre>
          </v-tab-item>

          <v-tab-item v-for="m in measures" :key="m.id">
            <pre>{{ m | prettyJson }}</pre>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import _ from 'lodash'
import { Heartbeat } from '@/models'
import { Range } from './heartbeats/ExportHbsDialog.vue'

export default {
  data() {
    return {
      currentTab: 'overview',
      hb: null
    }
  },
  computed: {
    overview() {
      return _.omit(this.hb, 'measures')
    },
    measures() {
      return this.hb.measures || []
    },
    startColor() {
      if (Range.start == null) return null
      if (this.hb != null && Range.start == this.hb.id) return 'green'
      return 'orange'
    },
    endColor() {
      if (Range.end == null) return null
      if (this.hb != null && Range.end == this.hb.id) return 'green'
      return 'orange'
    }
  },
  methods: {
    markStart() {
      Range.markStart(this.hb.clientId, this.hb.id)
    },
    markEnd() {
      Range.markEnd(this.hb.clientId, this.hb.id)
    },
    open(hbId) {
      this.hbId = hbId
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      this.hb = await Heartbeat.findById(this.hbId)
    }
  }
}
</script>

<style lang="sass">
.hb-dialog
  max-height: calc(100vh - 150px)
</style>
